export default __webpack_public_path__ + "static/media/NI-GT2001.e9d0b2c0.jpg";